module.exports = "<div class=\"form-rich-editor form-cell\"> <div class=wrap> <div class=content> {{#if unvisible}} <p class=info>权限受限</p> {{else if be_control_condition}} <p class=info>被修改条件限制</p> {{else}} <div class=toolbar></div> <div class=editor></div> {{/if}} <div style=float:left class=form-print-icon> {{#if required}} <span id=requiredLogo class={{requiredClass}}></span> {{/if}} </div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/editor-control/editor.html
// module id = 2055
// module chunks = 50